module.exports = __webpack_public_path__ + "img/serviceplanner-planning-parts-overlay-en.8b214caa.webp";